export default __webpack_public_path__ + "static/media/scale.b6ab9926.svg";